import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { getRehydratableName, getClassNameFactory } from "../../../../utilities";
import ChevronDownIcon from "@dcl/icons/esm/ui/chevron-down";
import ChevronUpIcon from "@dcl/icons/esm/ui/chevron-up";

var Selected = function Selected(_ref) {
  var children = _ref.children,
      clearAllHref = _ref.clearAllHref,
      clearAllText = _ref.clearAllText,
      title = _ref.title;
  var getClassName = getClassNameFactory("SearchFiltersSelected");

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setState = _useState2[1];

  var handleToggle = function handleToggle() {
    return setState(!isExpanded);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      states: isExpanded ? "expanded" : ""
    }),
    "data-clear-all-href": clearAllHref,
    "data-clear-all-text": clearAllText,
    "data-rehydratable": getRehydratableName(Selected.displayName),
    "data-title": title
  }, /*#__PURE__*/React.createElement("button", {
    className: getClassName({
      descendantName: "title"
    }),
    onClick: handleToggle
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "titleInner"
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "titleText"
    })
  }, title), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "toggleIcon"
    })
  }, isExpanded ? /*#__PURE__*/React.createElement(ChevronUpIcon, null) : /*#__PURE__*/React.createElement(ChevronDownIcon, null)))), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inner"
    })
  }, /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      descendantName: "items"
    })
  }, children), /*#__PURE__*/React.createElement("a", {
    className: getClassName({
      descendantName: "clearAll"
    }),
    href: clearAllHref
  }, clearAllText)));
};

Selected.displayName = "SearchFilters.Selected";
Selected.defaultProps = {
  clearAllText: "Clear all filters",
  title: "Selected filters"
};
export default Selected;